import { SxProps, Theme } from '@mui/material/styles';
import { useSessionStorage } from 'usehooks-ts';

import { MOBILE_APP_CLUB_CODE, ValidClubCode } from '../constants/mobileApp';
import { CLUB_ACCENT_GRADIENT } from '../styles/themes/cardStyles';
import { enableMobileWebviewUi } from './useGetFeatureFlags';

const accentStyles: Record<ValidClubCode, string> = {
  '005': '#003087',
  '212': CLUB_ACCENT_GRADIENT,
  '006': '#377d9f',
};

/** Accents used before the MWG styling update, kept for when the flag is off. */
const legacyAccentStyles: Record<ValidClubCode, string> = {
  '005': CLUB_ACCENT_GRADIENT,
  '212': CLUB_ACCENT_GRADIENT,
  '006': '#377d9f',
};

const borderStyles: Partial<Record<ValidClubCode, string>> = {
  '005': '1.5px solid #d1d3d4',
};

const useClubCardStyles = (): SxProps<Theme> => {
  const [clubCode] = useSessionStorage(MOBILE_APP_CLUB_CODE, '');

  if (!clubCode || !(clubCode in accentStyles)) {
    return {};
  }

  const code = clubCode as ValidClubCode;
  const accent = enableMobileWebviewUi
    ? accentStyles[code]
    : legacyAccentStyles[code];
  const border = enableMobileWebviewUi ? borderStyles[code] : undefined;

  return {
    boxShadow: 'none',
    borderRadius: 4,
    overflow: 'hidden',
    position: 'relative',
    pb: '4px',
    ...(border && { border }),
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      height: '4px',
      background: accent,
    },
  };
};

export default useClubCardStyles;
